import { render, staticRenderFns } from "./BaseCoursePicker.vue?vue&type=template&id=c91d2b86&scoped=true&"
import script from "./BaseCoursePicker.vue?vue&type=script&lang=js&"
export * from "./BaseCoursePicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseCoursePicker.vue?vue&type=style&index=0&id=c91d2b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91d2b86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c91d2b86')) {
      api.createRecord('c91d2b86', component.options)
    } else {
      api.reload('c91d2b86', component.options)
    }
    module.hot.accept("./BaseCoursePicker.vue?vue&type=template&id=c91d2b86&scoped=true&", function () {
      api.rerender('c91d2b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseCoursePicker.vue"
export default component.exports